import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountryService } from 'src/app/Shared/Country/country.service';
import { Country } from 'src/app/ViewModels/Country';
import * as $ from 'jquery';
import { AuditorTransactionService } from 'src/app/Shared/auditortransaction/auditor-transaction.service';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {
  closeResult: any;
  CountryName: any;
  countryname: any;
  CountryDesc: any;
  countrydesc: any;
  public dismissalert = false;
  notify: string
  CountryList: any;
  p: number = 1;
  editcountryName: any;
  editdesc: any;
  editcontryid: any;
  ucountryname: any;
  ucountrydesc: any;
  createdon: any;
  createdby: any;
  DeleteName: any;
  deleteid: any;
  uid: string;
  roleid: string;
  mobileview: boolean;
  inputstring:any;
  constructor(private modalService: NgbModal,private auditortransactionservice:AuditorTransactionService, private spinner: NgxSpinnerService, private countryService: CountryService) {
    this.inputstring = "InputString";

    if (localStorage.getItem("IsLoggedIn") == "true") {
      this.uid = localStorage.getItem("userId");
      this.roleid = localStorage.getItem("role");

    }
    this.isMobileMenu();
   }
   isMobileMenu() {
    if ($(window).width() > 991) {
       this.mobileview = false;
    }
    else {
      this.mobileview= true;
    }
  };

  ngOnInit(): void {
    this.Countries();
    this.CountryName = "";
    this.CountryDesc = "";
  }
  Countries() {
    this.spinner.show();
    this.countryService.getAllCountries().subscribe((Data: any) => {
      this.CountryList = Data;
      this.spinner.hide();

    })
  }
  addCountry(addcountry) {
      this.modalService.open(addcountry).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  EditCountry(updatedata, updatecountry) {
    this.editcountryName = updatedata.countryName
    this.editdesc = updatedata.countryDesc
    this.editcontryid = updatedata.countryId
    this.createdon = updatedata.createdOn;
    this.createdby=updatedata.createdBy;
    this.modalService.open(updatecountry).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     
    });
  }
  deleteCountry(deletedata,deletecountry) {
    this.DeleteName=deletedata.countryName;
    this.deleteid = deletedata.countryId;
    this.modalService.open(deletecountry).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  SaveCountry() {
    const inputRequest: Country = {
      CountryId: 0,
      CountryName:this.countryname,
      CountryDesc:this.countrydesc,
      CreatedBy: "",
      CreatedOn: "",
      ModifiedBy: "",
      ModifiedOn: "",
      UserId:this.uid 
    }
    this.spinner.show();
    this.countryService.saveCountry(inputRequest).subscribe(
      (data: any) => {
        if (data == "success") {
          this.notify = "Country added successfully"
          const audit = {
            TransactionName:"Master",
            TransactionType:"Create",
            TransactionDesc:"Country master",
           
            }
          this.auditortransactionservice.AuditorTransactionDetails(audit);
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.spinner.hide();
          this.Countries();
        } else {
          this.notify = "Something went wrong!!! Please Try Again.!!"
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.spinner.hide();
          this.Countries();
        }
      });
  }

  UpdateCountry() {
    const inputRequest1: Country = {
      CountryId: this.editcontryid,
      CountryName: this.editcountryName,
      CountryDesc: this.editdesc,
      CreatedBy:  this.createdby,
      CreatedOn:  this.createdon,
      ModifiedBy: "",
      ModifiedOn: "",
    UserId:this.uid 
    }
    this.spinner.show();
    this.countryService.UpdateCountry(inputRequest1).subscribe(
      (data: any) => {
        if (data == "success") {
          this.notify = "Country updated successfully"
          const audit = {
            TransactionName:"Master",
            TransactionType:"Update",
            TransactionDesc:"Country master",
           
            }
          this.auditortransactionservice.AuditorTransactionDetails(audit);
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.Countries();
          this.spinner.hide();
        } else {
          this.notify = "Something went wrong!!! Please Try Again.!!"
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.Countries();
          this.spinner.hide();
        }
      });
  }
  DeleteCountryRow() {
    this.spinner.show();
    this.countryService.deleteCountry(this.deleteid).subscribe(
      (data: any) => {
        if (data =="success") {
          this.notify = "Country Deleted Successfully"
          const audit = {
            TransactionName:"Master",
            TransactionType:"Delete",
            TransactionDesc:"Country master",
           
            }
          this.auditortransactionservice.AuditorTransactionDetails(audit);
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.Countries();
          this.spinner.hide();

        } else {
          this.notify = "Something went wrong!!! Please Try Again.!!"
          setTimeout(() => this.dismissalert = true, 100);
          setTimeout(function () {
            this.dismissalert = false;
          }.bind(this), 1000);
          this.Countries();
          this.spinner.hide();
        }
      });
  }
  closealert(){
    this.dismissalert=false;
  }
}
